import StoreLayout from "../../../components/store-layout.js";

const Frags = () => {
  return (
    <>
      <h1>Frags</h1>
      <p> All Frags can be picked up locally or shipped. </p>
      <StoreLayout type={"frags"} />
    </>
  );
}

export default Frags;